export const API_HOST = "~REPLACE_API_HOST~";

export const API_ROOT = '/api/v1';

export default class Urls {

    public static PUBLIC_SERVERS_CARDS = API_ROOT + '/public/serversCards';
    public static PUBLIC_CONTACT = API_ROOT + '/public/contact';

    public static ADMIN_INVITE_PASSWORD = API_ROOT + '/password';
    public static LOGIN = API_ROOT + '/login';
    public static LOGOUT = API_ROOT + '/logout';
    public static REFRESH_TOKEN = API_ROOT + '/refresh';

    public static ADMIN_USERS = API_ROOT + '/users';
    public static ADMIN_USER = API_ROOT + '/users/{userId}';
    public static ADMIN_REGISTER = API_ROOT + '/register';

    public static USER_PROFILE = API_ROOT + '/profile';
    public static USER_UPDATE_NAME = API_ROOT + '/profile/name';
    public static USER_UPDATE_PASSWORD = API_ROOT + '/profile/password';

    public static ADMIN_APPLICATIONS = API_ROOT + '/applications';
    public static ADMIN_UPDATE_DELETE_APPLICATION = API_ROOT + '/applications/{applicationId}';
    public static ADMIN_APPLICATION_VERSIONS = API_ROOT + '/applications/{applicationId}/versions';
    public static ADMIN_APPLICATION_DEPLOY = API_ROOT + '/applications/{applicationId}/deploy';

    public static ADMIN_SERVERS = API_ROOT + '/applications/{applicationId}/servers';
    public static ADMIN_SERVERS_ACTION = API_ROOT + '/applications/{applicationId}/servers/action';
    public static ADMIN_SERVER = API_ROOT + '/applications/{applicationId}/servers/{serverId}';
    public static ADMIN_SERVER_DEPLOY = API_ROOT + '/applications/{applicationId}/servers/{serverId}/deploy';
    public static ADMIN_SERVER_ACTION = API_ROOT + '/applications/{applicationId}/servers/{serverId}/action';

}

export class Constants {

    public static CLIENT_ID = 'WEB_PORTAL';
    public static CLIENT_SECRET = 'webui';
}